var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("שכפול תרגול")]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogReportPaid__Component__Loading" },
          [
            _c(
              "b-field",
              { attrs: { label: "קורס:" } },
              [
                _c("FieldInlineSelect", {
                  attrs: {
                    label: "קורס",
                    filterable: true,
                    clearable: true,
                    optionsAsync: _vm.getCourses,
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.courseId,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "courseId", $$v)
                    },
                    expression: "model.courseId",
                  },
                }),
              ],
              1
            ),
            _vm.model.courseId
              ? _c(
                  "b-field",
                  { attrs: { label: "יחידת לימוד:" } },
                  [
                    _c("FieldInlineSelect", {
                      attrs: {
                        label: "יחידת לימוד",
                        filterable: true,
                        clearable: true,
                        optionsAsync: _vm.getCourseLessons,
                      },
                      on: { onChange: _vm.onChange },
                      model: {
                        value: _vm.model.lessonId,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "lessonId", $$v)
                        },
                        expression: "model.lessonId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._m(0),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-top": "20px" } }, [
      _c("h1", [_vm._v("שימו לב:")]),
      _c("div", [_vm._v("1. התרגול ישוכפל ליחידת הלימוד הרצויה")]),
      _c("div", [_vm._v("2. התרגול המשוכפל יהיה בסטטוס 0")]),
      _c("div", [
        _vm._v("2. באפשרותך לשכפל תרגול רק לקורסים להם יש לך הרשאות מנהל "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }